<template>
  <div>
    <b-row>
      <b-col>
        <h2>Where do you want to travel ?</h2>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col cols="4" class="my-2" v-for="(cn, i) in country_city_options" :key="i">
        <b-row class="m-1 sg-badge-selection" :class="{ selected: country === cn._id, selected_temp: temp_country === cn._id }" v-b-toggle="`collapse-${i}`" @click="setTempCountry(cn._id)">
          <b-col class="px-3 center-base vertical" style="font-size: 22px; word-break: break-word;">
            {{ cn.country_name }}
          </b-col>
          <b-col cols="3" class="p-1 text-right">
            <b-img
              :src="require(`@/assets/icon/landmark/${cn.country_name}.png`)"
              fluid
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-collapse accordion="sg-city-accordion" :id="`collapse-${i}`" :visible="country === cn._id" v-for="(cn, i) in country_city_options" :key="i">
      <b-card class="text-center">
        <b-row>
          <b-col class="p-3" cols="4" v-for="(ct, j) in cn.city" :key="j">
            <div class="sg-badge-selection" v-b-tooltip.hover.bottom="'Guide me in this city!'" :class="{ selected: city === ct._id }" @click="setCountryCity(cn._id, ct._id)">
              {{ ct.city_name }}
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Order_ModalCountryCity',
  props: ['country', 'city', 'country_city_options'],
  components: {
  },
  data () {
    return {
      temp_country: ''
    }
  },
  methods: {
    // PREREQUISITES
    setTempCountry: function (country) {
      this.temp_country = country
    },
    setCountryCity: function (newCountry, newCity) {
      this.$emit('setCountryCity', newCountry, newCity)
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-badge-selection {
  background-color: #dddddd;
  border: 3px solid #dddddd;
  border-radius: 5px;
  cursor: pointer;

  padding: 10px;
  font-size: 18px;
  text-align: center;
}
.sg-badge-selection.selected {
  border: 3px solid #919dbd;
  background-color: #c8cede;
}
.selected_temp,
.sg-badge-selection:hover {
  border: 3px solid #233c7c;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/ModalCountryCity/ModalCountryCity.vue